export default {
  "content": "<path d=\"M6.5 11.5a5.5 5.5 0 0011 0V11h2v.5a7.5 7.5 0 01-6.5 7.432V22h-2v-3.068A7.5 7.5 0 014.5 11.5V11h2v.5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2a3.5 3.5 0 013.5 3.5v6a3.5 3.5 0 01-6.995.18L8.5 11.5v-6A3.5 3.5 0 0112 2zm0 2a1.5 1.5 0 00-1.5 1.5v6l.008.153A1.5 1.5 0 0013.5 11.5v-6A1.5 1.5 0 0012 4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};